export const BOOT_SPLASH_CSS = `
#js-boot-splash {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f2f4;
}
#js-boot-splash.is-done {
  display: none !important;
}
.js-boot-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 77px;
}
.js-boot-block {
  display: block;
  flex: none;
  border-radius: 999px;
  animation-duration: 2.7s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.65, 0, 0.35, 1);
}
.js-boot-a {
  width: 41px;
  height: 41px;
  background: linear-gradient(160deg, #fee516 0%, #f4e51f 47%, #37e4d2 100%);
  animation-name: js-boot-a;
}
.js-boot-b {
  width: 41px;
  height: 77px;
  background: linear-gradient(180deg, #37e4d2 0%, #ffabe7 100%);
  animation-name: js-boot-b;
}
.js-boot-c {
  width: 77px;
  height: 41px;
  background: linear-gradient(135deg, #ffda2b 0%, #ffa5e5 100%);
  animation-name: js-boot-c;
}
.js-boot-d {
  width: 41px;
  height: 41px;
  background: linear-gradient(90deg, #ff761a 0%, #ffabe7 100%);
  animation-name: js-boot-d;
}
@keyframes js-boot-a {
  0%, 22.222% { width: 41px; height: 41px; }
  33.333%, 44.444% { width: 77px; height: 41px; }
  55.555%, 100% { width: 41px; height: 41px; }
}
@keyframes js-boot-b {
  0%, 22.222% { width: 41px; height: 77px; }
  33.333%, 88.889% { width: 41px; height: 41px; }
  100% { width: 41px; height: 77px; }
}
@keyframes js-boot-c {
  0%, 22.222% { width: 77px; height: 41px; }
  33.333%, 44.444% { width: 41px; height: 41px; }
  55.555%, 66.667% { width: 41px; height: 77px; }
  77.778%, 100% { width: 77px; height: 41px; }
}
@keyframes js-boot-d {
  0%, 44.444% { width: 41px; height: 41px; }
  55.555%, 66.667% { width: 77px; height: 41px; }
  77.778%, 100% { width: 41px; height: 41px; }
}
`;

const POLARIS_READY_TIMEOUT_MS = 8000;

let bootSplashHidden = false;
const bootSplashListeners = new Set();

function whenPolarisReady() {
  if (typeof customElements === "undefined") {
    return Promise.resolve();
  }
  if (customElements.get("s-page")) {
    return Promise.resolve();
  }
  return Promise.race([
    customElements.whenDefined("s-page"),
    new Promise((resolve) => {
      setTimeout(resolve, POLARIS_READY_TIMEOUT_MS);
    }),
  ]);
}

export function hideBootSplashWhenUiReady() {
  whenPolarisReady().then(() => {
    hideBootSplash();
  });
}

export function isBootSplashHidden() {
  if (bootSplashHidden) {
    return true;
  }
  if (typeof window !== "undefined" && window.__JS_BOOT_HIDDEN__) {
    return true;
  }
  if (typeof document !== "undefined") {
    return Boolean(
      document.getElementById("js-boot-splash")?.classList.contains("is-done"),
    );
  }
  return false;
}

export function hideBootSplash() {
  const alreadyHidden = bootSplashHidden;
  bootSplashHidden = true;

  if (typeof window !== "undefined") {
    window.__JS_BOOT_HIDDEN__ = 1;
  }

  if (typeof document !== "undefined") {
    document.getElementById("js-boot-splash")?.classList.add("is-done");
  }

  if (!alreadyHidden) {
    bootSplashListeners.forEach((listener) => listener());
  }
}

export function subscribeBootSplashHidden(listener) {
  if (isBootSplashHidden()) {
    listener();
  }
  bootSplashListeners.add(listener);
  return () => {
    bootSplashListeners.delete(listener);
  };
}
